import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEn from "resource/translation.en.json";
import translationKo from "resource/translation.ko.json";
import { getLanguage } from 'script/common'

const lang = getLanguage();
const resource = {
	en_US: {
	  translation: translationEn,
	},
	ko_KR: {
	  translation: translationKo,
	}
  };

  i18n.use(initReactI18next).init({
	resources: resource,
	lng: lang,
	fallbackLng: lang,
	debug: true,
	interpolation: { escapeValue: false },
});

export default i18n;